import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import STOCKDashboard from 'images/stock.png';
export default function StockDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('stockdashboardText', { ns: ['home'] })}</Typography>
      <img src={STOCKDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}